export enum OrderAssetStorageType {
    Cloud = 1,
    OnPrem = 2
}
